/* eslint-disable react/jsx-no-useless-fragment */
import useMaybeNotSetupUser from "contexts/MaybeNotSetupUser/useMaybeNotSetupUser";
import useAwaitableModal from "hooks/useAwaitableModal";
import AccountantAppLayout from "layouts/App/Accountant";
import {AccountantProfile, AccountantProposals, Setup} from "pages/accountant";
import RecruiterProfilePage from "pages/accountant/Recruiter";
import {FC, useEffect} from "react";
import {Navigate, Route, Routes} from "react-router";
import AccountantSignUp from "modals/AccountantSignUp";
import {IAccountant} from "api/types";
import CraigRouter from "./craig";
import {maybeNotSetupRef} from "..";
import ChatsPage, {ChatPage} from "pages/Chat";
import AnnouncementsPage from "pages/Announcements";
import SettingsPage from "pages/accountant/Settings";
import Loader from "components/loaders/Loader";

const AccountantRouter: FC = () => {
  const user = useMaybeNotSetupUser().user as IAccountant | undefined;
  const [showOnboarding, OnboardingModal] = useAwaitableModal(AccountantSignUp, {} as any);

  useEffect(() => {
    if (user?.justSignedUp) {
      maybeNotSetupRef.current?.setUser?.({...user, justSignedUp: false});
      showOnboarding().catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {OnboardingModal}
      <Routes>
        <Route path="setup" element={user ? <Navigate to="/" replace /> : <Setup />} />
        <Route path="craig" element={user ? <CraigRouter /> : <></>} />
        <Route
          path="*"
          element={
            user === undefined ? (
              <div className="flex-1 flex items-center justify-center">
                <Loader />
              </div>
            ) : user ? (
              <AccountantAppLayout />
            ) : (
              <Navigate to="/setup" replace />
            )
          }
        >
          <Route path="profile" element={<AccountantProfile />} />
          <Route path="messages" element={<AnnouncementsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="proposals" element={<AccountantProposals />} />
          <Route path="recruiter/:id" element={<RecruiterProfilePage />} />
          <Route path="chat" element={<ChatsPage />}>
            <Route
              index
              element={
                <div className="grow p-10 flex flex-col justify-start items-center">
                  <span className="text-lg text-primary-blue">No chat selected</span>
                </div>
              }
            />
            <Route path=":chatId" element={<ChatPage />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export default AccountantRouter;
